var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_24904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1815 47.5C37.6079 47.5 47.6815 37.4264 47.6815 25C47.6815 12.5736 37.6079 2.5 25.1815 2.5C12.7551 2.5 2.68152 12.5736 2.68152 25C2.68152 37.4264 12.7551 47.5 25.1815 47.5Z",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_856_24904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9216 21.5481C36.5231 21.901 37.0218 22.4051 37.3684 23.0103C37.715 23.6154 37.8973 24.3007 37.8973 24.9981C37.8973 25.6955 37.715 26.3808 37.3684 26.986C37.0218 27.5911 36.5231 28.0952 35.9216 28.4481L22.2056 36.4731C21.5979 36.8287 20.9071 37.0175 20.203 37.0206C19.499 37.0237 18.8066 36.8409 18.1958 36.4906C17.585 36.1404 17.0775 35.6351 16.7245 35.0259C16.3716 34.4167 16.1857 33.7252 16.1856 33.0211V16.9751C16.1857 16.271 16.3716 15.5795 16.7245 14.9703C17.0775 14.3611 17.585 13.8558 18.1958 13.5056C18.8066 13.1554 19.499 12.9725 20.203 12.9756C20.9071 12.9787 21.5979 13.1676 22.2056 13.5231L35.9216 21.5481Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_856_24904",
    x: 10.1855,
    y: 9.97559,
    width: 33.7118,
    height: 36.0449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.322 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_856_24904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_856_24904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_24904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.637,
    height: 52,
    fill: "white",
    transform: "translate(0.181519)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay1);
export default __webpack_public_path__ + "static/media/play1.e0b61fdfb14865ddbcb77f33b4a4b57a.svg";
export { ForwardRef as ReactComponent };